import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Divider, MenuItem, styled, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { removeNulls } from 'utils';
export const SwipableMenuItem = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'disabled',
})(({ disabled }) => ({
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '8px 16px',
    justifyContent: 'space-between',
    opacity: disabled ? 0.5 : 1,
    pointerEvents: disabled ? 'none' : 'all',
}));
export const DefaultMenuItem = styled(MenuItem, {
    shouldForwardProp: (prop) => prop !== 'disabled',
})(({ disabled }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '6px 12px',
    opacity: disabled ? 0.5 : 1,
    cursor: 'pointer',
    pointerEvents: disabled ? 'none' : 'all',
}));
export const UniversalMenuItem = memo(function UniversalMenuItem(props) {
    const { onClick, disabled = false, label, icon, divider = { position: 'bottom', content: undefined }, additional_view, data_tooltip, type = 'default', } = props;
    const MenuItem = type === 'swipable' ? SwipableMenuItem : DefaultMenuItem;
    const nextUiGuide = useAppSelector((state) => state.ui_guide_state.store_helpers.next);
    const onMenuItemClick = useCallbacks(removeNulls([preventDefault, (event) => onClick?.(event), nextUiGuide]));
    const divider_content = useMemo(() => {
        if (divider.content === true) {
            return _jsx(Divider, {});
        }
        if (divider.content !== undefined) {
            return (_jsx(Divider, { sx: {
                    whiteSpace: 'normal',
                    '& .MuiDivider-wrapper': {
                        minWidth: 200,
                        maxWidth: 350,
                    },
                }, children: divider.content }));
        }
        return null;
    }, [divider]);
    return (_jsxs(_Fragment, { children: [divider.position === 'top' && divider_content, _jsxs(MenuItem, { onClick: onMenuItemClick, disabled: disabled, "data-tooltip": data_tooltip, children: [_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 1.5, children: [_jsx(Box, { display: "flex", justifyContent: "center", alignItems: "center", fontSize: "1.5rem", children: icon }), _jsx(Typography, { color: "textPrimary", children: label })] }), additional_view] }), (divider.position === 'bottom' || !divider.position) && divider_content] }));
});
